<div class="header-text">Actions to Address Root Causes</div>
<p class="text-muted">Corrective action must describe the action taken to prevent recurrence.</p>

<div Id="correctiveActionSection">
    @for (action of incidentReport.correctiveActions; track $index) {
        <div class="row row-cols-1 row-cols-md-3 row-cols-lg-5 g-2 mb-3 align-items-end mt-3">
            <div class="col">
                <label class="form-label">Specific action item completed:<span class="text-danger">*</span></label>
                <dx-text-box stylingMode="filled" [(value)]="action.actionItem" maxLength="100" placeholder="Enter action item"
                    [readOnly]="isReadOnly">
                    <dx-validator>
                        <dxi-validation-rule type="required" max="100" message="Action item is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="col">
                <label class="form-label">Who is responsible: <span class="text-danger">*</span></label>
                <dx-text-box stylingMode="filled" [(value)]="action.responsiblePerson" maxLength="100"
                    placeholder="Enter responsible person" [readOnly]="isReadOnly">
                    <dx-validator>
                        <dxi-validation-rule type="required" max="100"
                            message="Responsible person is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="col">
                <label class="form-label">Target date: <span class="text-danger">*</span></label>
                <dx-date-box [(value)]="action.targetDate" stylingMode="filled" [useMaskBehavior]="true"
                    [displayFormat]="dateFormat" [readOnly]="isReadOnly">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Target date is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-date-box>
            </div>
            <div class="col">
                <label class="form-label">Date completed: <span class="text-danger">*</span></label>
                <dx-date-box [(value)]="action.completedDate" stylingMode="filled" [useMaskBehavior]="true"
                    [displayFormat]="dateFormat" [readOnly]="isReadOnly">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Date completed is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-date-box>
            </div>
            <div class="col text-start">
                @if (!isReadOnly) {
                    @if ($index === incidentReport.correctiveActions!.length - 1) {
                        <dx-button text="Add" icon="plus" type="default" class="me-2" stylingMode="outlined" (onClick)="addAction()">
                        </dx-button>
                    }
                    @if ($index > 0) {
                        <dx-button text="Remove" icon="trash" type="danger" stylingMode="outlined" (onClick)="removeAction($index)">
                        </dx-button>
                    }
                }
            </div>
        </div>
    }
</div>
<div class="row mt-4" id="WorkTrainingSection">
    <div class="col-md-6">
        <dx-check-box [(value)]="incidentReport.workOrderSent" text="Work Order sent" [readOnly]="isReadOnly"
            (onValueChanged)="scrollWorkTrainingToSectionEnd($event)">
        </dx-check-box>
        @if (incidentReport.workOrderSent) {
            <div class="mt-3">
                <div class="mb-2">
                    <label class="form-label">Work Order #: <span class="text-danger">*</span></label>
                    <dx-text-box stylingMode="filled" [(value)]="incidentReport.workOrderNumber" maxLength="100"
                        placeholder="Enter work order number" [readOnly]="isReadOnly">
                        <dx-validator>
                            <dxi-validation-rule type="required" max="100"
                                message="Work Order Number is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="mb-2">
                    <label class="form-label">Target Date for Completion: <span class="text-danger">*</span></label>
                    <dx-date-box [(value)]="incidentReport.workOrderTargetCompletionDate" stylingMode="filled"
                        [useMaskBehavior]="true" [displayFormat]="dateFormat" [readOnly]="isReadOnly">
                        <dx-validator>
                            <dxi-validation-rule type="required"
                                message="Target Date for Completion is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-date-box>
                </div>
                <div class="mb-2">
                    <label class="form-label">Date Complete: <span class="text-danger">*</span></label>
                    <dx-date-box [(value)]="incidentReport.workOrderActualCompletionDate" stylingMode="filled"
                        [useMaskBehavior]="true" [displayFormat]="dateFormat" [readOnly]="isReadOnly">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Date Complete is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-date-box>
                </div>
            </div>
        }
    </div>
    <div class="col-md-6">
        <dx-check-box [(value)]="incidentReport.reTrainingNeeded" text=" Re-Training needed" [readOnly]="isReadOnly"
            (onValueChanged)="scrollWorkTrainingToSectionEnd($event)">
        </dx-check-box>
        @if (incidentReport.reTrainingNeeded) {
            <div class="mt-3">
                <div class="mb-2">
                    <label class="form-label">Re-Training Topic: <span class="text-danger">*</span></label>
                    <dx-text-box stylingMode="filled" [(value)]="incidentReport.reTrainingTopic" maxLength="100"
                        placeholder="Enter re-training topic" [readOnly]="isReadOnly">
                        <dx-validator>
                            <dxi-validation-rule type="required" max="100"
                                message="Re-Training Topic is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="mb-2">
                    <label class="form-label">Trainer: <span class="text-danger">*</span></label>
                    <dx-text-box stylingMode="filled" [(value)]="incidentReport.reTrainingTrainer" maxLength="100"
                        placeholder="Enter trainer name" [readOnly]="isReadOnly">
                        <dx-validator>
                            <dxi-validation-rule type="required" max="100"
                                message="Trainer is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="mb-2">
                    <label class="form-label">Target Date for Completion: <span class="text-danger">*</span></label>
                    <dx-date-box [(value)]="incidentReport.reTrainingTargetCompletionDate" stylingMode="filled"
                        [useMaskBehavior]="true" [displayFormat]="dateFormat" [readOnly]="isReadOnly">
                        <dx-validator>
                            <dxi-validation-rule type="required"
                                message="Target Date for Completion is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-date-box>
                </div>
                <div class="mb-2">
                    <label class="form-label">Date Complete: <span class="text-danger">*</span></label>
                    <dx-date-box [(value)]="incidentReport.reTrainingActualCompletionDate" stylingMode="filled"
                        [useMaskBehavior]="true" [displayFormat]="dateFormat" [readOnly]="isReadOnly">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Date Complete is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-date-box>
                </div>
            </div>
        }
    </div>
</div>